export default __webpack_public_path__ + "static/media/darkModeLogo.5b5324de.png";